import React from 'react'
import { Table, TableBody, TableCell, TableRow, Skeleton } from '@mui/material'

export const AccountSummary = (props) => {
  const { data = {}, isLoading, additionalInfo = [] } = props

  const infoArray = [
    { label: 'Account Number', id: 'companyAccountId' },
    { label: 'Company Name', id: 'companyName' },
    { label: 'Sales', id: 'salesId' },
    { label: 'Total Point', id: 'totalPoint' },
    ...additionalInfo,
  ]

  return (
    <Table
      sx={{
        display: 'inline-block',
        border: 'none',
        '& .MuiTableCell-root': { borderBottom: 'none' },
        marginBottom: 8,
      }}
    >
      <TableBody>
        {infoArray.map((info, idx) => (
          <TableRow key={idx}>
            <TableCell>{info.label}</TableCell>
            <TableCell>
              {isLoading ? <Skeleton width={120} /> : info.view ? info.view(data) : data?.[info.id]}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  )
}
